<template>
  <div class="text-block block-card card-border ">
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <v-icon class="white--text text-lg-2">date_range</v-icon>
            </div>

            <h4>
              Date Time Input 
              <v-icon 
                v-if = "errorsCount && errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <form-validation v-model = "errorsCount" v-if="validData">
          <div class="block-card-body" v-if="validData">

            <label for="">Type</label>
            <v-radio-group 
              v-model="data.hasTime" 
              row>
              <v-radio
                :value="false"
                label="Date"
              />
              <v-radio
                :value="true"
                label="Time"
              />
            </v-radio-group>

            <label for="">Message</label>
            <vTextareaAutocomplete
              v-model="data.message"
              :type="'textarea'"
              :validation-rules=" [v => !!v || 'Message is Required']"
              :counter="1000"
            />

            <label>Save Answer To Attribute</label>
            <v-text-field
              v-model="data.save_to_attribute"
              :error="!data.save_to_attribute"
              :error-messages="!data.save_to_attribute? 'Attribute is Required':'' "
              outline
            />

            <label for="">Button Label</label>
            <vTextareaAutocomplete
              v-model="data.buttonTitle"
              :type="'textfield'"
              :validation-rules=" [v => !!v || 'Button label is Required']"
              :counter="20"
            />

            <label for="">Error message</label>
            <vTextareaAutocomplete
              v-model="data.errorMessage"
              :type="'textarea'"
              :validation-rules=" [v => !!v || 'Error message is Required']"
              :counter="1000"
            />

            <label for="">Cancel button label</label>
            <vTextareaAutocomplete
                v-model="data.cancelButtonLabel"
                :type="'textfield'"
                :validation-rules=" [v => !!v || 'Cancel button label is Required']"
                :counter="1000"
            />

            <label for="">Cancel redirect block</label>
            <v-autocomplete
                :items="blocksList"
                v-model="data.cancelRedirectBlock"
                item-text="name"
                item-value="id"
                outline
                solo
                chips
            />



          </div>
        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from '../../../../utils/common'
import FormValidation from '../FormValidation'
export default {
  name: 'CardDateTimeInput',
  components: {
    FormValidation
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    },
    validData: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
      autocompleteImageUrlValidationrRules: [
        v => !!v || 'Image url is required'
      ]
    }
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    }
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
  },
  methods: {}
}
</script>

<style scoped>
</style>
